// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tapu_fini: PokeData = {
  "id": 788,
  "name": "tapu-fini",
  "height": 13,
  "weight": 212,
  "base_experience": 257,
  "types": [
    PokeType.WATER,
    PokeType.FAIRY
  ],
  "api_moves": [
    "mist",
    "water-gun",
    "hydro-pump",
    "surf",
    "withdraw",
    "haze",
    "mean-look",
    "whirlpool",
    "refresh",
    "muddy-water",
    "water-pulse",
    "brine",
    "aqua-ring",
    "defog",
    "soak",
    "heal-pulse",
    "disarming-voice",
    "misty-terrain",
    "moonblast",
    "natures-madness"
  ],
  "moves": [
    "hydro-pump",
    "whirlpool",
    "refresh",
    "brine",
    "misty-terrain",
    "moonblast",
    "play-rough",
    "bubble",
    "aqua-tail",
    "sweet-kiss",
    "aqua-jet",
    "bubble-beam",
    "life-dew"
  ],
  "evolution_chain": {
    "id": 412,
    "item": null,
    "species": [
      {
        "name": "tapu-fini",
        "order": 788,
        "types": [
          PokeType.WATER,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 139,
    "speed": 123,
    "ability_power": 138
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
